import React from 'react';
import styled from 'styled-components';
import moment from 'moment-timezone';
import { Link } from 'react-router-dom';

const Date = styled.span`
  font-weight: bold;
`;

export const StyledLink = styled(Link)`
  color: #0046FF
`;

const { baseUrl } = window.conviva;
interface IProps {
  timestamp: string;
  id: number
}
const Timestamp = ({
  timestamp,
  id,
}: IProps) => {
  const time = moment(timestamp).format('HH:mm');
  const date = moment(timestamp).format('MMM DD YYYY');
  if (time.toLocaleLowerCase() === 'invalid date') {
    return <>-</>;
  }
  return (
    <StyledLink
      to={`${baseUrl}/alert/manual/diagnostics/?event=${id}`}
      // Enabled for new tab workflow :: newBrowserTab
      // target="_blank"
      // rel="noopener noreferrer"
    >
      {`${time}, `}
      <Date>{date}</Date>
    </StyledLink>
  );
};

export default Timestamp;
